import { format, parseISO } from 'date-fns'

import { type FormatFn } from './Format.types'

export const DateFormatter: FormatFn<string> = (value) => {
  const parsedDate = parseISO(value)
  return format(parsedDate, 'MMM dd, yyyy')
}
